


const dashboardSection = $('#dashboard-section');
const dashboardCardTitles = dashboardSection.find('.dashboard-card-title');
const dashboardCardTexts = dashboardSection.find('.dashboard-card-text');
const dashboardCardProgress = dashboardSection.find('.dashboard-card-progress-status');
const dashboardCardProgressController = dashboardSection.find('.dashboard-card-progress-controller');
const dashboardGraphSlides = dashboardSection.find('.dashboard-lottie-player');
const dashboardSlider = dashboardSection.find('.slider-nav-parent');

gsap.set(dashboardCardProgressController, {
  width : `${100 / dashboardCardTitles.length}%`,
  left: (index) => `${100 / dashboardCardTitles.length * index}%`
});

dashboardGraphSlides.each(function (i) {
  $(this).css('z-index', `${1000 - i}`);
  $(this).toggleClass('is-active', i === 0);
});

const resetCardsForStart = () => {
  dashboardCardTitles.each((i, el) => {
    $(el).css({ opacity: i === 0 ? 1 : 0, y: i === 0 ? 0 : '2.5vw' });
  });
  dashboardCardTexts.each((i, el) => {
    $(el).css({ opacity: i === 0 ? 1 : 0, y: i === 0 ? 0 : '1.25vw' });
  });
};

const showGraphSlide = (index) => {
  dashboardGraphSlides.each((i, el) => {
    $(el).toggleClass('is-active', i === index);
  });
};

const animateGraphCard = (graphIndex, duration) => {
  const lottieLength = dashboardGraphSlides.length;
  const cardTL = gsap.timeline({ paused: true });
  const progressStart = (100 / lottieLength) * graphIndex;
  const progressEnd = (100 / lottieLength) * (graphIndex + 1);
  const prevIndex = (graphIndex - 1 + lottieLength) % lottieLength;
  const currentTitle = dashboardCardTitles.eq(graphIndex);
  const prevTitle = dashboardCardTitles.eq(prevIndex);
  const currentText = dashboardCardTexts.eq(graphIndex);
  const prevText = dashboardCardTexts.eq(prevIndex);

  const cardEase1 = CustomEase.create('cardEase1', '0.00, 0.00, 0.20, 1.00');
  const cardEase2 = CustomEase.create('cardEase2', '0.80, 0.00, 1.00, 1.00');

  cardTL.fromTo(
    dashboardCardProgress,
    { width: `${progressStart}%` },
    { width: `${progressEnd}%`, duration: duration, ease: 'none' },
    0
  );

  cardTL.fromTo(
    prevTitle,
    { y: '0', opacity: 1 },
    { y: '-1.875vw', opacity: 0, duration: 0.667, ease: cardEase2, onStart: () => {
      changeSliderStep(dashboardSlider, dashboardGraphSlides, prevIndex, graphIndex);
    }},
    0
  );

  cardTL.fromTo(
    currentTitle,
    { y: '2.5vw', opacity: 0 },
    { y: 0, opacity: 1, duration: 0.5, ease: cardEase1 },
    0.5
  );

  cardTL.fromTo(
    prevText,
    { y: '0', opacity: 1 },
    { y: '-1.25vw', opacity: 0, duration: 0.667, ease: cardEase2 },
    0
  );

  cardTL.fromTo(
    currentText,
    { y: '1.25vw', opacity: 0 },
    { y: 0, opacity: 1, duration: 0.5, ease: cardEase1 },
    0.5
  );

  return cardTL;
};

const animateGraphLoop = (duration) => {
  const loopTL = gsap.timeline({ paused: true, repeat: -1 });
  const lottieLength = dashboardGraphSlides.length;

  for (let i = 0; i < lottieLength; i++) {
    loopTL.addLabel(`step${i}`, duration * i);

    loopTL.call(() => showGraphSlide(i), null, `step${i}`);
    
    loopTL.add(animateGraphCard(i, duration).play(), `step${i}`);
  }

  return loopTL;
};
const addProgressControl = (loopTL) => {
  const nextBtn = dashboardSlider.find('.slider-nav-btn.next');
  const labels = Object.entries(loopTL.labels);
  const duration = loopTL.duration();

  nextBtn.on('click', () => {
    const t = loopTL.time();
    labels.forEach(([name, start], index) => {
      const next = labels[index + 1];
      const [nextName, nextStart] = next ? next : [labels[0][0], duration];
      if (t >= start && t < nextStart) loopTL.seek(nextName);
    });
  });
};

const addProgressController = (loopTL) => {
  const progressControllers = dashboardSection.find('.dashboard-card-progress-controller');
  progressControllers.each(function () {
    $(this).on('click', () => {
      const id = $(this).attr('id').replace('controller-', '');
      loopTL.seek(`step${id}`);
    });
  });
};

const addDashboardLottie = () => {
  const duration = 8;
  addSliderSteps(dashboardSlider, dashboardGraphSlides)
  addSliderInAnimation(dashboardSlider, true, 50, true);
  const loopTL = animateGraphLoop(duration);

  ScrollTrigger.create({
    trigger: dashboardSection,
    start: 'top top+=120%',
    end: 'top top',
    once: true,
    onEnter: () => {
      resetCardsForStart();
      loopTL.play();
      addProgressControl(loopTL);
      addProgressController(loopTL);
    },
  });
};

addSectionObserver(dashboardSection, addDashboardLottie);
